<img
  (click)="logoClicked()"
  alt="CSS Pensions"
  i18n-alt
  [style.height]="height"
  [style.width]="width"
  [src]="logoImage$ | async" />
